<template>
    <v-dialog v-model="dialog" scrollable max-width="800">
        <template v-slot:activator="{ props }">
            <v-btn
                icon
                v-bind="props"
                color="secondary"
                class="text-capitalize text-typography3"
            >
                <v-icon size="x-large" color="secondary">
                    mdi-folder-edit
                </v-icon>
            </v-btn>
        </template>
        <v-card>
            <v-card-title class="mb-4"
                >Edit library version status</v-card-title
            >
            <v-card-text>
                <div>
                    <!-- Why is the selected radio dissapearing? Ah well, admin feature -->
                    <v-radio-group v-model="libstatus">
                        <v-radio label="Public" name="l" :value="1"></v-radio>
                        <v-radio
                            label="Background"
                            name="l"
                            :value="2"
                        ></v-radio>
                        <v-radio label="Labs" name="l" :value="3"></v-radio>
                        <v-radio
                            label="End of life"
                            name="l"
                            :value="4"
                        ></v-radio>
                    </v-radio-group>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-btn
                    class="text-capitalize text-typography3"
                    color="secondary"
                    :disabled="!canUpdate"
                    @click="update"
                >
                    Update
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'

const props = defineProps({
    libver: { type: Object, required: true },
})

const store = useStore()
const dialog = ref(false)
const libstatus = ref(props.libver.libraryVersionStatusId)

const canUpdate = computed(
    () => libstatus.value !== props.libver.libraryVersionStatusId
)

function update() {
    store.dispatch('patchLibraryVersionStatus', {
        libVerId: props.libver.libraryVersionId,
        statusId: libstatus.value,
    })
    dialog.value = false
}
</script>
